import React from "react";
import "./Pictures.css";

const Pictures = () => (
  <div className="pictures-page">
    <h2 className="pictures-title">Photos</h2>
    <p className="pictures-coming-soon">Coming soon</p>
  </div>
);

export default Pictures;
